module.exports = __webpack_public_path__ + "window_configuration-ba9135098b7b97e0f93744b7f9a40fda.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/assets/window_configuration.png
// module id = KT9c
// module chunks = client